
import type { SvgIconProps } from "@mui/material"
import { CustomIcon } from "../../../common/Icon/CustonIcon"

export const MigrationIcon = (props: SvgIconProps) => (
    <CustomIcon
        svgContent={
            <>
                <rect x="5" y="6" width="14" height="12" stroke="currentColor" fill="none" strokeWidth="1.5" />
                <path
                    d="M12 12H17M17 12L14 9M17 12L14 15"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </>
        }
        {...props}
    />
)

